$(document).on('click', '.bold_option_value_element', function () {
  console.log($(this).attr('aria-label'));
  var $titleElement = $(this).closest('.bold_option.bold_option_swatch').find('.bold_option_title');
  var $existingLabel = $titleElement.siblings('.labelname');
  var option = $(this).attr('aria-label').replace('color option:',  '');
  option = option.replace(' color option: ', '');
  option = option.trim(); // Remove extra spaces
  
  if ($existingLabel.length === 0) {
    $('<span class="labelname">'+ option + '</span>').insertAfter($titleElement);
  } else {
    $existingLabel.text(option);
  }
});
function optiontable() {
  if ($('.option-list').length == 1) {
    var productoptions = $('.option-list').text();
    productoptions = productoptions.substring(1);
    productoptions = productoptions.split('|');
    console.log(productoptions);
    var sku = productoptions[0].split(',');
    var finish = productoptions[1].substring(1).split(',');
    var msrp = productoptions[2].substring(1).split(',');
    var price = productoptions[3].substring(1).split(',');
    var saleprice = productoptions[4].substring(1).split(',');
    if (typeof productoptions[5] != 'undefined') {
      var variantid = productoptions[5].substring(1).split(',');
    } else {
      var variantid = new Array(sku.length);
    }
    if (typeof productoptions[6] != 'undefined') {
      var ships = productoptions[6].substring(1).split(',');
    } else {
      var ships = new Array(sku.length);
    }
    if (typeof productoptions[7] != 'undefined') {
      var mpn = productoptions[7].substring(1).split(',');
    } else {
      var mpn = new Array(sku.length);
    }

    var lowprice = 9999;
    var lowmsrp = 9999;
    var shippingtable = '';

    var i;
    var buildtable;
    $('.option-list').hide();
    for (i = 0; i < sku.length; i++) {
      console.log(productoptions[6]);
      if (typeof productoptions[5] === 'undefined') {
        variantid[i] = '#';
      }
      if (typeof productoptions[6] === 'undefined') {
        ships[i] = 0;
      }
      if (+saleprice[i] > 0) {
        buildtable +=
          '<tr data-mpn="' +
          mpn[i] +
          '" data-vid="' +
          variantid[i] +
          '" class="pdrow onsale" data-saleprice="' +
          saleprice[i] +
          '" data-finish="' +
          finish[i] +
          '" data-pdsku="' +
          sku[i] +
          '" data-pdprice=' +
          price[i] +
          ' data-pdmsrp=' +
          msrp[i] +
          '><td>' +
          mpn[i] +
          '</td>' +
          '<td>' +
          finish[i] +
          '</td>' +
          '<td>$' +
          Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td>' +
          '<td><strike>$' +
          Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</strike> On Sale $' +
          Number(saleprice[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td></tr>';
        shippingtable +=
          '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
      } else {
        buildtable +=
          '<tr data-mpn="' +
          mpn[i] +
          '" data-vid="' +
          variantid[i] +
          '" class="pdrow" data-pdsku="' +
          sku[i] +
          '" data-pdprice=' +
          price[i] +
          ' data-pdmsrp=' +
          msrp[i] +
          ' data-finish="' +
          finish[i] +
          '"><td>' +
          mpn[i] +
          '</td>' +
          '<td>' +
          finish[i] +
          '</td>' +
          '<td>$' +
          Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td>' +
          '<td>$' +
          Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td></tr>';
        shippingtable +=
          '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
      }
      if (price[i] < lowprice) {
        lowprice = price[1];
      }
      if (msrp[i] < lowmsrp) {
        lowmsrp = msrp[1];
      }
    }
    $('#productdetails').html(
      '<thead><tr><td>MPN</td><td>Finish</td><td>Retail Price</td><td>Our Price</td></tr></thead>' + buildtable
    );
    $('.optionstable').append('<div class="shiptable" style="display:none;">' + shippingtable + '</div>');

    /*console.log(lowmsrp);
      console.log(lowprice);
      $('#ProductPrice').html('From: $'+lowprice);
      $('#ComparePrice').html('$'+lowmsrp);*/
  } else if ($('.option-list').length > 1) {
    $('.option-list').each(function () {
      var productoptions = $(this).text();
      productoptions = productoptions.substring(1);
      productoptions = productoptions.split('|');

      var sku = productoptions[0].split(',');
      var finish = productoptions[1].substring(1).split(',');
      var msrp = productoptions[2].substring(1).split(',');
      var price = productoptions[3].substring(1).split(',');
      var saleprice = productoptions[4].substring(1).split(',');
      if (typeof productoptions[5] != 'undefined') {
        var variantid = productoptions[5].substring(1).split(',');
      } else {
        var variantid = new Array(sku.length);
      }
      if (typeof productoptions[6] != 'undefined') {
        var ships = productoptions[6].substring(1).split(',');
      } else {
        var ships = new Array(sku.length);
      }
      var lowprice = 9999;
      var lowmsrp = 9999;
      var shippingtable = '';

      var i;
      var buildtable;
      $('.option-list').hide();
      for (i = 0; i < sku.length; i++) {
        console.log(sku[i]);
        if (typeof productoptions[5] === 'undefined') {
          variantid[i] = '#';
        }
        if (typeof productoptions[6] === 'undefined') {
          ships[i] = 0;
        }
        if (+saleprice[i] > 0) {
          buildtable +=
            '<tr data-vid="' +
            variantid[i] +
            '" class="pdrow onsale" data-saleprice="' +
            saleprice[i] +
            '" data-finish="' +
            finish[i] +
            '" data-pdsku="' +
            sku[i] +
            '" data-pdprice=' +
            price[i] +
            ' data-pdmsrp=' +
            msrp[i] +
            '><td>' +
            sku[i] +
            '</td>' +
            '<td>' +
            finish[i] +
            '</td>' +
            '<td>$' +
            Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td>' +
            '<td><strike>$' +
            Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</strike> On Sale $' +
            Number(saleprice[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td></tr>';
          shippingtable +=
            '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
        } else {
          buildtable +=
            '<tr data-vid="' +
            variantid[i] +
            '" class="pdrow" data-pdsku="' +
            sku[i] +
            '" data-pdprice=' +
            price[i] +
            ' data-pdmsrp=' +
            msrp[i] +
            ' data-finish="' +
            finish[i] +
            '"><td>' +
            sku[i] +
            '</td>' +
            '<td>' +
            finish[i] +
            '</td>' +
            '<td>$' +
            Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td>' +
            '<td>$' +
            Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td></tr>';
          shippingtable +=
            '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
        }
        if (price[i] < lowprice) {
          lowprice = price[1];
        }
        if (msrp[i] < lowmsrp) {
          lowmsrp = msrp[1];
        }
      }

      $('<div class="shiptable" style="display:none;">' + shippingtable + '</div>').insertAfter($('#PageContainer'));

      /*console.log(lowmsrp);
        console.log(lowprice);
        $('#ProductPrice').html('From: $'+lowprice);
        $('#ComparePrice').html('$'+lowmsrp);*/
    });
  } else {
    $('.options-component').hide();
  }

  if ($('.specifications').length) {
    $('.specifications').appendTo('.pspectext');
  } else {
    $('.ptab-spec').hide();
  }

  function commas(str) {
    return str.replace(/.(?=(?:.{3})+$)/g, '$&,');
  }

  if ($('.additional-info').length) {
    $('.additional-info').appendTo('.pinfotext');
  } else {
    $('.ptab-info').hide();
  }
  $('.pdrow').on('click', function () {
    var urlsplit = window.location.pathname.split('?');
    document.location = urlsplit + '?variant=' + $(this).data('vid');
  });
  if (window.location.href.indexOf('variant') > -1 && $('.pdrow').length > 0) {
    var variantid = window.location.href.split('?variant=');

    if (variantid[1].indexOf('&gclid') > -1) {
      var varsplit = variantid[1].split('&gclid');
      var price = $('.pdrow[data-vid="' + varsplit[0] + '"]').data('pdprice');
      var msrp = $('.pdrow[data-vid="' + varsplit[0] + '"]').data('pdmsrp');
      var sku = $('.pdrow[data-vid="' + varsplit[0] + '"]').data('mpn');
      $('#ProductPrice').html('$' + price.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('#ComparePrice').html('$' + msrp.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('.variant-sku').html(sku);
    } else {
      var price = $('.pdrow[data-vid="' + variantid[1] + '"]').data('pdprice');
      var msrp = $('.pdrow[data-vid="' + variantid[1] + '"]').data('pdmsrp');
      var sku = $('.pdrow[data-vid="' + variantid[1] + '"]').data('mpn');
      price = Number(price);
      msrp = Number(msrp);
      $('#ProductPrice').html('$' + price.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('#ComparePrice').html('$' + msrp.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('.variant-sku').html(sku);
    }
  }
}
optiontable();

$(document).on('click', '.footer-info-heading', function () {
  console.log('clicked');
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('.footer-info-list').slideUp();
    $(this).parent().find('ul').removeClass('active');
  } else {
    $('.footer-info-heading').removeClass('active');
    $(this).addClass('active');
    $('.footer-info-list').slideUp();
    $(this).parent().find('ul').addClass('active');
    $(this).parent().find('ul').slideDown();
  }
});

$(document).on('click', '#acc-toggle', function () {
  $(this).toggleClass('active');
  $(this).parent().find('.acc-dd').slideToggle();
});

function scrollToSpecs() {
  const targetElement = document.querySelector('#product-info');
  if (targetElement) {
    const headerOffset = 100; // Adjust this value based on your header height
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
}

$('.swatch-input__label').on('click', function () {
  var selectedValue = $(this).attr('title');
  $('#swatch-selectlist').val(selectedValue);
});


const intervalcoa = setInterval(function () {
  $('.ss-item:not(".pricechecked")').each(function () {
    $(this).addClass('pricechecked');

    if ($(this).attr('result-json').indexOf('calltoorder') > -1) {
      $('<div class="coalink">Call to Order</div>').insertAfter($(this).find('.price--on-sale'));
    }
  });
}, 500);

$(document).on('click', '.coalink', function () {
  $('#coa-pop').show();
  $('#coa-overlay').show();
  $('.leadtime-content').hide();
  $('.coa-content').show();
});
$(document).on('click', '#coa-close, #coa-overlay, .coa-chat', function () {
  $('#coa-pop').hide();
  $('#coa-overlay').hide();
});

$(document).on('click', '.shippingcontact', function (e) {
  e.preventDefault();
  $('#coa-pop').show();
  $('#coa-overlay').show();
  $('.leadtime-content').show();
  $('.coa-content').hide();
});

$(document).ready(function () {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    } else {
      alert('You must agree with the terms and conditions of sales to check out.');
      return false;
    }
  });
});

$(document).ready(function () {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    } else {
      alert('You must agree with the terms and conditions of sales to check out.');
      return false;
    }
  });
});

var inter = setInterval(function () { 
    $('.bold_options.bold_options_loaded .bold_option.bold_option_dropdown, .bold_options.bold_options_loaded .bold_option.bold_option_uploadfile, .bold_options.bold_options_loaded .bold_option.bold_option_telephone, .bold_options.bold_options_loaded .bold_option.bold_option_date, .bold_options.bold_options_loaded .bold_option.bold_option_color, .bold_options.bold_options_loaded .bold_option.bold_option_email, .bold_options.bold_options_loaded .bold_option.bold_option_number, .bold_options.bold_options_loaded .bold_option.bold_option_textboxmulti, .bold_options.bold_options_loaded .bold_option.bold_option_textarea, .bold_options.bold_options_loaded .bold_option.bold_option_textbox, .bold_options.bold_options_loaded .bold_option.bold_option_dropdownmulti,  .bold_options.bold_options_loaded .bold_option.bold_option_swatch, .bold_options.bold_options_loaded .bold_option.bold_option_radio, .bold_options.bold_options_loaded .bold_option.bold_option_checkbox, .bold_options.bold_options_loaded .bold_option.bold_option_checkboxmulti '
    ).each(function () {
      if ($(this).find('.cta-bold-view-more').length > 0) {
        return;
      }

      if ($(this).find('span.bold_tooltip').html()) {
        $(this)
          .find('span.bold_option_title')
          .append('<a href="javascript:void(0)"  class="help cta-bold-view-more">View More </a>');
        $(this)
          .find('span.bold_tooltip')
          .after("<div class='bold_tooltip aictv'>" + $(this).find('span.bold_tooltip small').html() + '</br></div>');
        $(this).find('span.bold_tooltip').remove();
      }
    });
}, 500);

$('body').on('click', 'a.cta-bold-view-more', function () {
  if ($(this).hasClass('act')) {
    $(this).text('View More ');
    $(this).removeClass('act');
    // $(this).parent().next().slideUp();
    //$(this).parent().next().removeClass("actvv");
  } else {
    //$(this).parent().next().addClass("actvv");
    $(this).text('Hide More ');
    $(this).addClass('act');
    //$(this).parent().next().slideDown();
  }
  if ($(this).parent().parent().find('.bold_tooltip').hasClass('aictv')) {
    $(this).parent().parent().find('.bold_tooltip').slideToggle();
  } else {
    $(this).parent().parent().parent().find('.bold_tooltip').slideToggle();
  }
});



console.log('custom.js loaded');
